import React, { useState } from 'react';
import { Provider, defaultState } from './context';

const NotificationProvider = (props) => {
  const [notification, setNotification] = useState(defaultState.notification);

  /**
   * Returns True if type and text are in the current notification array
   * @param  {string} type -- the type of notification
   * @param  {string} text -- the descriptive text in the toast notification
   * @param  {Object} extraOptions - Any extra params you want to add in the toast notification
   * @return {bool}      If type and text combo are already present
   */
  const checkNotifications = (type, text) => {
    let check = false;
    const notifications = [...notification];

    notifications.forEach((notification) => {
      if (notification.text !== text || notification.type !== type) {
        check = true;
      }
    });

    return check;
  };

  const addNotification = (type, text, extraOptions) => {
    const newNotification = {
      isOpen: true,
      type,
      text,
      extraOptions,
    };
    setNotification((prev) => [...prev, newNotification]);
  };

  const handleNotification = (type, text) => {
    let notifications = notification;
    notifications = notifications.filter((notification) => {
      if (notification.text !== text || notification.type !== type) {
        return notification;
      }
      return null;
    });
    setNotification(notifications);
  };

  const providerValue = {
    notification,
    addNotification,
    handleNotification,
    checkNotifications,
  };

  return <Provider value={providerValue}>{props.children}</Provider>;
};

export default NotificationProvider;
